<template>
  <div class="reconciliation-mobile-item" @click="$emit('click', $event)">
    <div class="d-flex align-center mb-2">
      <e-checkbox 
        v-if="!hideCheckbox" 
        v-model="selected"
        @click.stop  
      />

      <v-spacer />

      <reconciliation-status :status="item.commonInfo.orderReconciliationStatus" class="mr-2" />

      <list-context-menu 
        :item="item" 
        v-if="!isPeriodReconciled" 
        :period-status="periodStatus"
        :can-edit="canEdit"
        @view-details="$emit('view-details', item)"
        @reconciled="$emit('reconciled')"
      />
    </div>

    <div class="paragraph-l_h d-flex align-center mb-2">
      <router-link :to="{ name: RouteNames.Book, params: { b_id: item.commonInfo.orderId } }" class="link font-600">
        {{ item.commonInfo.reconciliationItemTitle }}
      </router-link>

      <v-spacer />

      <div>
        {{ item.commonInfo.reconciliationItemSubTitle }}
      </div>
    </div>

    <div class="d-flex align-center mb-2 font-600 flex-wrap">
      <e-icon name="calendarTick" size="20" class="text-ordinary mr-1" />
      <div class="paragraph-s_h text-secondary ws-nw">
        {{ getDatePeriod(item.commonInfo.period.from, item.commonInfo.period.to, true) }}
      </div>
      <div class="mx-3 color-border-light">|</div>
      <e-icon name="userMultiple" size="20" class="text-ordinary mr-1" />
      <div class="paragraph-s_h text-secondary mr-2">
        {{ item.commonInfo.tourists.length }}
      </div>

      <v-spacer />
      <cancelled-status :status="item.commonInfo.orderAvoidanceStatus" />
    </div>

    <div class="d-flex align-center">
      <div class="th text-ordinary">Выплаты</div>
      <v-spacer />
      <div class="td font-600 text-secondary">
        {{ formatPrice(item.commonInfo.amountsInfo.payout) }}
      </div>
    </div>
    <div class="d-flex align-center">
      <div class="th text-ordinary">К оплате</div>
      <v-spacer />
      <div class="td font-600 text-secondary">
        {{ formatPrice(item.commonInfo.amountsInfo.payable) }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import CancelledStatus from './cancelled-status.vue';
import ListContextMenu from './list-context-menu.vue';
import ReconciliationStatus from './reconciliation-status.vue';
import type { Reconciliation } from '../types';
import { ECheckbox, EIcon } from '@/core/components/ui';
import { RouteNames } from '@/core/plugins/router/routeNames';
import { getDatePeriod } from '@/core/utils/date';
import { formatPrice } from '@/core/utils/number';
import { ContractReconciliationStates } from '@/graphql/generated';

const props = defineProps<{
  item: Reconciliation;
  periodStatus?: ContractReconciliationStates;
  hideCheckbox?: boolean;
  canEdit?: boolean;
}>();

defineEmits<{
  (event: 'click', e: MouseEvent): void;
  (event: 'update:model-value', value: boolean): void;
  (event: 'reconciled'): void;
  (event: 'view-details', item: Reconciliation): void; 
}>();

const isPeriodReconciled = computed(
  () => props.periodStatus === ContractReconciliationStates.Reconciled
);

const selected = defineModel<boolean>({ required: true });
</script>

<style scoped lang="scss">
.reconciliation-mobile-item {
  padding: 16px;

  background-color: $main-bg-color;
  border-radius: $border-radius-l;
}
</style>
